module.exports = __webpack_public_path__ + "img/mobile-burger.d2dd8e36.svg";